// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"2bd79258","136":"79f1d62b","220":"fe81ffe6","280":"5dbd4b64","300":"a39a3669","320":"fb7b1fa1","404":"2c02d09b","512":"a707390f","516":"4503e649","592":"734d5a43","856":"dce983a9","872":"2816ee1c","952":"cbb41b17","992":"b8c047c8"}[chunkId] + ".chunk.js";
};